import { render, staticRenderFns } from "./TeamKolChangeList.vue?vue&type=template&id=5041fb6c&scoped=true"
import script from "./TeamKolChangeList.vue?vue&type=script&lang=js"
export * from "./TeamKolChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5041fb6c",
  null
  
)

export default component.exports